import { render, staticRenderFns } from "./three-guarantees.vue?vue&type=template&id=0da5c031&"
import script from "./three-guarantees.vue?vue&type=script&lang=js&"
export * from "./three-guarantees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports